import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Alert,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import api from "../../api";
import PolicyContent from "../../components/PolicyContent/PolicyContent";
import { AuthContext } from "../../context/AuthContext";

const AcceptPrivacyPolicy = () => {
  const navigate = useNavigate();
  const { objUserTk } = useContext(AuthContext);
  const [accepted, setAccepted] = useState(false);
  const [rejected, setRejected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAccept = async () => {
    setLoading(true);
    setError(null);
    try {
      // Empresas (Type 2) e candidatos (Type 1) registram o aceite em endpoints distintos.
      const endpoint =
        String(objUserTk.Type) === "2"
          ? "/Company/accept-privacy-policy"
          : "/Candidate/accept-privacy-policy";
      await api.post(endpoint);
      navigate("/admin/index");
    } catch (err) {
      console.error("Erro ao registrar o aceite da política de privacidade:", err);
      setError(
        "Não foi possível registrar o seu aceite. Tente novamente mais tarde."
      );
      setLoading(false);
    }
  };

  const handleReject = () => {
    setRejected(true);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        backgroundColor: "#f7fafc",
        padding: "2rem 0",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col lg="10" md="11">
            <div className="text-center mb-4">
              <img
                src={require("../../assets/img/brand/logoAtt.png")}
                alt="Portal Carreira"
                style={{ maxHeight: 80 }}
              />
            </div>

            <Card className="shadow">
              <CardBody className="p-4">
                <p className="text-muted text-center mb-4">
                  Para continuar utilizando o Portal Carreira, é necessário ler e
                  aceitar a nossa Política de Privacidade e Termos de Uso, em
                  conformidade com a Lei Geral de Proteção de Dados (Lei nº
                  13.709/2018). Role o documento até o final para revisar o conteúdo
                  completo.
                </p>

                {/* Texto completo da política em área rolável */}
                <div
                  style={{
                    maxHeight: "55vh",
                    overflowY: "auto",
                    border: "1px solid #e9ecef",
                    borderRadius: "0.375rem",
                    padding: "1.25rem",
                    backgroundColor: "#fbfcfe",
                  }}
                >
                  <PolicyContent />
                </div>

                {error && (
                  <Alert color="danger" className="mt-3">
                    {error}
                  </Alert>
                )}

                {!rejected ? (
                  <>
                    <FormGroup check className="mt-4">
                      <Input
                        type="checkbox"
                        id="accept-policy-checkbox"
                        checked={accepted}
                        onChange={(e) => setAccepted(e.target.checked)}
                        disabled={loading}
                      />
                      <Label check for="accept-policy-checkbox">
                        Li e aceito a Política de Privacidade e os Termos de Uso
                        (versão 1.0).
                      </Label>
                    </FormGroup>

                    <div
                      className="d-flex flex-column flex-md-row justify-content-center mt-3"
                      style={{ gap: "1rem" }}
                    >
                      <Button
                        color="primary"
                        onClick={handleAccept}
                        disabled={loading || !accepted}
                      >
                        {loading ? "Processando..." : "Continuar"}
                      </Button>
                      <Button
                        color="secondary"
                        outline
                        onClick={handleReject}
                        disabled={loading}
                      >
                        Não aceito
                      </Button>
                    </div>
                  </>
                ) : (
                  <Alert color="danger" className="mt-4">
                    <h4 className="alert-heading">Seu acesso foi bloqueado.</h4>
                    <p>
                      Como você optou por não aceitar a Política de Privacidade, seu
                      acesso à plataforma está suspenso.
                    </p>
                    <p className="mb-0">
                      Caso queira solicitar a exclusão dos seus dados pessoais ou tenha
                      dúvidas, entre em contato pelo e-mail{" "}
                      <strong>suporte@propagandistadeprimeira.com.br</strong>.
                    </p>
                  </Alert>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AcceptPrivacyPolicy;
